import CategoriesDrawer from './CategoriesDrawer'
export default CategoriesDrawer
